// ---------------------------------------------
// Lazy Loading - DeSight Shopify Theme
// ---------------------------------------------
// Intersection Observer für Lazy Loading von Bildern
// ---------------------------------------------

import { $$ } from '../utils/helpers.js';

export function initLazyLoad() {
  if (!('IntersectionObserver' in window)) return;

  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const img = entry.target;
      if (img.dataset.src) {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      }
      observer.unobserve(img);
    });
  }, { rootMargin: '100px' });

  $$('img[data-src]').forEach(img => imageObserver.observe(img));
}
